import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { IAvatarInputProps } from './types';
import Avatar from 'react-avatar-edit';
import { AvatarFileInput } from './AvatarFileInput';
import { useDispatch } from 'react-redux';
import {
  clearFormAvatar,
  saveCropCounter,
  saveFormAvatar,
} from '../../../../../app/page/page-storage/users/user-form/user-form.actions';

export const AvatarInput: FunctionComponent<IAvatarInputProps> = ({
  id,
  name,
  defaultValue,
  validation,
  label,
  maxImageSize,
  acceptableFormats,
  helpText,
}) => {
  const [cropCounter, setCropCounter] = useState(0);
  const src = defaultValue ? defaultValue : '';
  const [rerender, setRerender] = useState(true);
  const [avatar, setAvatar] = useState({ preview: undefined, src });

  const dispatch = useDispatch();

  // Only once effect, on loading
  useEffect(() => {
    // reset the counter in the Redux Store when the control initiates
    dispatch(saveCropCounter(0));
  }, [dispatch]);

  const onClose = useCallback(() => {
    console.debug('onClose');
    // increment the cropcounter to indicate a change
    setCropCounter(cropCounter + 1);
    setAvatar({ ...avatar, preview: undefined });
    dispatch(clearFormAvatar());
    dispatch(saveCropCounter(cropCounter + 1));
  }, [avatar, cropCounter, dispatch]);

  const onCrop = useCallback(
    (preview) => {
      // increment the cropcounter to indicate a change
      setCropCounter(cropCounter + 1);
      setAvatar({ ...avatar, preview: preview });
      dispatch(saveFormAvatar(preview));
      dispatch(saveCropCounter(cropCounter + 1));
      setRerender(false);
      setRerender(true);
    },
    [avatar, cropCounter, dispatch],
  );

  return (
    <>
      <div className="new-account-image">
        {avatar.preview ? (
          <img className="round-icon" alt="" src={avatar.preview ? avatar.preview : src} />
        ) : (
          <span className="round-icon">
            <i className="icon-image"></i>
          </span>
        )}
      </div>

      <Avatar
        width={120}
        height={80}
        onCrop={onCrop}
        cropRadius={40}
        onClose={onClose}
        labelStyle={{ fontSize: '12px' }}
        onFileLoad={onCrop}
        src={src}
        mimeTypes={'.jpg, .gif, .png, .webp'}
      />
      {/* {!avatar.preview && (
        <div className="new-account-desc" style={{ paddingLeft: '25px' }}>
          <p className="bold">{label}</p>
          <p className="small-text">
            {`Acceptable formats: ${acceptableFormats ? acceptableFormats : 'All'}. Max size: ${maxImageSize}mb.`}
          </p>
        </div>
      )} */}
      {rerender && (
        <AvatarFileInput
          id={id}
          name={name}
          label={label}
          maxImageSize={maxImageSize}
          acceptableFormats={acceptableFormats}
          validation={validation}
          defaultValue={avatar.preview ? avatar.preview : null}
          helpText={helpText}
        />
      )}
    </>
  );
};
